import React, { useContext, useState } from "react";
import { ConfirmDialog, DeleteButton, ListActionButtonProps, useNotifications } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../core/security/SprintAccessRight";
import { useDeliveryBucketsApi } from "../api/useDeliveryBucketsApi";
import { DeliveryBucketListingContext } from "../context/DeliveryBucketListingContext";
import { DeliveryBucketItem } from "../listing/DeliveryBucketItem";

type DeleteDeliveryBucketButtonProps = ListActionButtonProps<DeliveryBucketItem>;

export const DeleteDeliveryBucketButton: React.VFC<DeleteDeliveryBucketButtonProps> = ({
    itemId,
    disabled
}: DeleteDeliveryBucketButtonProps) => {
    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

    const { deleteDeliveryBucket } = useDeliveryBucketsApi();
    const { success } = useNotifications();
    const { deleteDeliveryBucketItem } = useContext(DeliveryBucketListingContext);

    const openDialog = () => {
        setIsDialogOpen(true);
    };

    const closeDialog = () => {
        setIsDialogOpen(false);
    };

    const handleDelete = async () => {
        await deleteDeliveryBucket({ deliveryBucketId: itemId });
        success("Bucket deleted");
        deleteDeliveryBucketItem(itemId);
        closeDialog();
    };

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.CiAdmin]}>
            <DeleteButton key={itemId} disabled={disabled} onClick={openDialog} />
            <ConfirmDialog
                title="Delete delivery bucket"
                text="Are you sure you want to delete this delivery bucket? This action is irreversible."
                hidden={!isDialogOpen}
                confirm={{ onClick: handleDelete }}
                cancel={{ onClick: closeDialog }}
            />
        </AuthorizationWrapper>
    );
};
